import { Box, Center, Text, VStack } from "@chakra-ui/layout";
import { Button, HStack } from "@chakra-ui/react";
import React from "react";
import { calculateGPA, calculateTotalHours } from "../utils";
import GradeField from "./GradeField";

class Calculator extends React.Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDeleteTerm = this.handleDeleteTerm.bind(this);
  }

  handleDeleteCourse(id) {
    this.props.handleDeleteCourse(this.props.id, id);
  }

  handleDeleteTerm() {
    this.props.deleteTerm(this.props.id);
  }

  handleInputChange(event, id) {
    let fieldIndex;

    for (let i = 0; i < this.props.fields.length; i++) {
      const field = this.props.fields[i];
      if (id === field.id) {
        fieldIndex = i;
        break;
      }
    }

    const key = event.target.name;
    const field = { ...this.props.fields[fieldIndex] };

    field[key] = event.target.value;

    this.props.handleInputChange(id, field);
  }

  render() {
    const gpa = calculateGPA(this.props.fields);
    const totalHours = calculateTotalHours(this.props.fields);

    return (
      <Box
        // border="1px solid #eeeeee"
        boxShadow="base"
        borderRadius="10px"
        py="9"
        my="6"
        maxW="960px"
        mx="auto"
        bg="white"
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mx="6"
          mb="4"
        >
          <Text alignItems="flex-start" fontSize="2xl" fontWeight="bold">
            {this.props.title}
          </Text>
          {totalHours > 0 && <Text>{totalHours} кр</Text>}
        </Box>

        {this.props.fields.map((field) => (
          <GradeField
            grade={field.grade}
            hours={field.hours}
            key={field.id}
            id={field.id}
            handleInputChange={this.handleInputChange}
            deleteField={this.props.handleDeleteCourse}
          />
        ))}
        <Center textAlign="center">
          <VStack>
            {gpa > -1 && (
              <Box
                fontSize="20"
                my="6"
                borderRadius="full"
                bg="teal.500"
                color="white"
                h="16"
                w="16"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Text fontWeight="bold">{gpa >= 0 ? " " + gpa : ""}</Text>
              </Box>
            )}
            <HStack>
              <Button
                _hover={{
                  background: "teal.500",
                  color: "white",
                }}
                onClick={() => this.props.handleAddCourse(this.props.id)}
              >
                Хичээл нэмэх
              </Button>
              <Button
                _hover={{
                  background: "red.500",
                  color: "white",
                }}
                onClick={() => this.handleDeleteTerm()}
              >
                Улирал устгах
              </Button>
            </HStack>
          </VStack>
        </Center>
      </Box>
    );
  }
}

export default Calculator;
